export enum RoutesPaths {
    PermissionsList = '/user-management/permissions',
    PermissionsDetail = '/user-management/permissions/:id',
    UserList = '/user-management/user/list',
    UserDetail = '/user-management/user/:id',
    IdentityLinking = '/user-management/microsoft-link',
}
